const tableTitleManagementEquip = {
  title: 'Gestión de equipos',
  placeholder: 'Buscar por los campos: número de serie, marca, especificación y referencia',
  helperTextSearch: 'Para buscar por el nombre del equipo, utiliza el filtro de tipo de equipo',
  addRowLabel: 'Nuevo equipo'
};

export default tableTitleManagementEquip;
